import { Sun, Moon } from 'lucide-react'

type SwitchProps = {
  value: 'light' | 'dark'
  onChange: (value: 'light' | 'dark') => void
}

const ThemeSwitch = ({ value, onChange }: SwitchProps) => {
  return (
    <div className='flex items-center gap-2 bg-background-gray-badge-light dark:bg-background-gray-badge rounded-md px-1 py-1 w-fit shadow-deep-light dark:shadow-deep-dark'>
      <button
        type='button'
        aria-label='Light mode'
        onClick={() => onChange('light')}
        className={`flex items-center justify-center w-8 h-8 rounded-full transition-colors ${
          value === 'light' ? 'bg-yellow-500 text-text-light' : 'text-text-dark'
        }`}
      >
        <Sun size={20} />
      </button>
      <button
        type='button'
        aria-label='Dark mode'
        onClick={() => onChange('dark')}
        className={`flex items-center justify-center w-8 h-8 rounded-full transition-colors ${
          value === 'dark' ? 'bg-background-general-dark text-text-dark' : 'text-text-light'
        }`}
      >
        <Moon size={20} />
      </button>
    </div>
  )
}

export { ThemeSwitch }
export type { SwitchProps }
